import projectAlertsComponent from './project-alerts.component';

const projectAlertsModule = angular.module('projectAlerts', [
])
  .component('projectAlerts', projectAlertsComponent)
  .name;

export default projectAlertsModule;
